import React, { useEffect, useRef } from 'react'
import { IonItem, IonLabel, IonIcon } from '@ionic/react'
import { caretDownOutline } from 'ionicons/icons'
import './MultiActionBar.component.css'

export interface IMultiActionBarProps {
  id: string
  label: string
  dataTestId?: string
  type: 'dropdown' | 'bottomSheetModal' | 'popover' | 'heading' | 'tabletSupportModal'
  className?: string
  disabled?: boolean
  onClick?: (e: any) => void
  onFocus?: (e: any) => void
  onBlur?: () => void
  onClose?: () => void
  isOpen?: boolean
  children?: React.ReactNode
  showCaretIcon?: boolean
}

const MultiActionBarHeader: React.FC<IMultiActionBarProps> = ({
  id = 'MultiActionBar',
  type,
  dataTestId,
  label,
  className = '',
  disabled,
  onClick,
  children,
  showCaretIcon = false,
  onClose,
  isOpen,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      if (onClose) onClose()
    }
  }

  useEffect(() => {
    if (type === 'dropdown' && isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [isOpen])

  return (
    <div
      ref={wrapperRef}
      id='MultiActionDynamicHeader'
      tabIndex={1}
      data-testid='MultiActionDynamicHeader'
      className={`${className} multi-action-heading`}>
      <IonItem
        id={id}
        data-testid={dataTestId}
        onClick={onClick}
        disabled={disabled}
        className='multi-action-heading-bar'>
        <IonLabel className='multi-action-header-label'>{label}</IonLabel>
        {showCaretIcon && (
          <IonIcon
            slot={label ? 'end' : 'start'}
            className='ion-icon-end'
            size='small'
            color='medium'
            icon={caretDownOutline}
          />
        )}
      </IonItem>
      {children}
    </div>
  )
}

export default MultiActionBarHeader
